import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const Auth = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    dateOfBirth: '',
    profilePicture: null
  });
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = (e) => {
    e.preventDefault();
    // Simuler une authentification
    login({ ...formData });
    navigate('/');
  };

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'profilePicture' && files) {
      setFormData(prev => ({ ...prev, [name]: files[0] }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  return (
    <div className="min-h-screen flex flex-col justify-center px-4 bg-gray-100">
      <div className="max-w-md mx-auto w-full">
        <div className="flex mb-8">
          <button
            className={`flex-1 py-3 text-center font-semibold border-b-2 ${
              isLogin ? 'border-pink-500' : 'border-transparent'
            }`}
            onClick={() => setIsLogin(true)}
          >
            Connexion
          </button>
          <button
            className={`flex-1 py-3 text-center font-semibold border-b-2 ${
              !isLogin ? 'border-pink-500' : 'border-transparent'
            }`}
            onClick={() => setIsLogin(false)}
          >
            Inscription
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          {!isLogin && (
            <input
              type="text"
              name="username"
              placeholder="Nom d'utilisateur"
              onChange={handleInputChange}
              className="w-full px-4 py-3 rounded-lg border focus:outline-none focus:border-pink-500"
              required
            />
          )}
          
          <input
            type="email"
            name="email"
            placeholder="Email"
            onChange={handleInputChange}
            className="w-full px-4 py-3 rounded-lg border focus:outline-none focus:border-pink-500"
            required
          />
          
          <input
            type="password"
            name="password"
            placeholder="Mot de passe"
            onChange={handleInputChange}
            className="w-full px-4 py-3 rounded-lg border focus:outline-none focus:border-pink-500"
            required
          />

          {!isLogin && (
            <>
              <input
                type="date"
                name="dateOfBirth"
                onChange={handleInputChange}
                className="w-full px-4 py-3 rounded-lg border focus:outline-none focus:border-pink-500"
                required
              />
              
              <input
                type="file"
                name="profilePicture"
                accept="image/*"
                onChange={handleInputChange}
                className="w-full px-4 py-3 rounded-lg border focus:outline-none focus:border-pink-500"
                required
              />
            </>
          )}

          <button
            type="submit"
            className="w-full bg-pink-500 text-white py-3 rounded-lg font-semibold hover:bg-pink-600 transition"
          >
            {isLogin ? 'Se connecter' : "S'inscrire"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Auth;
